import env from 'env-var'

export const H3_ENV = env.get('REACT_APP_H3_ENV').required().asString()
export const WEBEVENTS_URI = env
    .get('REACT_APP_WEBEVENTS_URI')
    .required()
    .asString()
export const APP_VERSION = env.get('REACT_APP_VERSION').required().asString()
export const H3_BASE_URI = env
    .get('REACT_APP_H3_BASE_URI')
    .required()
    .asString()
